import React from 'react';
import {Helmet} from 'react-helmet-async';

const SEO = ({
                 title,
                 description,
                 image,
                 url,
                 type = "website",
                 defaults = {}
             }) => {
    const canonicalUrl = `${window.location.href}`
    const originUrl = `${window.location.origin}`
    const appName = "Validation Station";
    const imageUrl = `${originUrl}/images/logo1024x512.png`

    title = `${title} - ${appName}` || defaults.title || `${appName}`;
    description = description || defaults.description || "V. Inovice OCR Platform";
    image = image || defaults.image || imageUrl;
    url = url || defaults.url || canonicalUrl;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description}/>

            {/* Open Graph tags */}
            <meta property="og:title" content={title}/>
            <meta property="og:description" content={description}/>
            <meta property="og:image" content={image}/>
            <meta property="og:url" content={url}/>
            <meta property="og:type" content={type}/>

            {/* Twitter Card tags */}
            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:title" content={title}/>
            <meta name="twitter:description" content={description}/>
            <meta name="twitter:image" content={image}/>
        </Helmet>
    );
};

export default SEO;